module.exports = __webpack_public_path__ + "img/icon_w.40ed21a3.svg";